<form class="row"
      novalidate
      [formGroup]="form"
      (ngSubmit)="submit()"
>
  <div class="col-12">
    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md" for="input-email">Email</label>
        <app-icon-feather *ngIf="email.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="email.dirty && email.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <input id="input-email"
             type="text"
             pInputText
             placeholder="your@email.com"
             name="email"
             [formControl]="email"
      >
      <div class="position-relative">
        <small class="p-error"
               *ngIf="email.dirty && email.invalid"
        >
          {{ getErrorMessage('Email', email) }}
        </small>
      </div>
    </div>

    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md">Password</label>
        <app-icon-feather *ngIf="password.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="password.dirty && password.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <app-password-complexity-check [control]="password"></app-password-complexity-check>
      <div class="position-relative">
        <small class="p-error"
               *ngIf="password.dirty && password.invalid"
        >
          {{ getErrorMessage('Password', password) }}
        </small>
      </div>
    </div>

    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md" for="input-password-repeat">Repeat Password</label>
        <app-icon-feather *ngIf="passwordRepeat.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="passwordRepeat.dirty && passwordRepeat.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <div class="password-input-wrap">
        <input id="input-password-repeat"
               pInputText
               placeholder="***************"
               autocomplete="off"
               name="password"
               [type]="passwordRepeatType"
               [formControl]="passwordRepeat"
        >
        <app-toggle-password-visibility [(inputType)]="passwordRepeatType"></app-toggle-password-visibility>
      </div>
      <div class="position-relative">
        <small class="p-error"
               *ngIf="passwordRepeat.dirty && passwordRepeat.invalid"
        >
          {{ getErrorMessage('Password', passwordRepeat) }}
        </small>
      </div>
    </div>






    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md">Pin</label>
        <app-icon-feather *ngIf="pin.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="pin.dirty && pin.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <app-pin-complexity-check [control]="pin"></app-pin-complexity-check>
      <div class="position-relative">
        <small class="p-error"
               *ngIf="pin.dirty && pin.invalid"
        >
          {{ getErrorMessage('Pin', pin) }}
        </small>
      </div>
    </div>


  </div>

  <div class="col-12 mt-5">
    <button pButton
            class="p-button-md w-100"
            type="submit"
            label="Submit"
            [disabled]="form.invalid || isSubmitting"
    ></button>
  </div>

  <div class="col-12">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <p class="mt-3">
        Back to
        <a class="p-link"
           routerLink="/auth/login"
        >
          Login page
        </a>
      </p>
      <p class="mt-3">
        <a class="p-link"
           routerLink="/auth/login"
        >
          <app-icon
            icon="i-9"
            width="24"
            height="24"
            tooltipPosition="left"
            pTooltip="Biometric login"
          ></app-icon>
        </a>
      </p>
    </div>
  </div>
</form>
